import React, { Suspense } from 'react';
import { ArrowLeft18 } from 'shared/assets/icons';
import { TopBarBase } from 'shared/components/connected/top-bar-base';
import { IconButton, Sizes } from 'shared/components/ui/icon-button';
import { useBackFunction } from 'shared/contexts/history';
import { Paths } from 'shared/routes/paths';

import { Interactions, LoadingInteractions } from './interactions';
import { NavigationTabs } from './navigation-tabs';
import * as Styled from './page-top-bar.style';
import { LoadingTitle, Title } from './title';

export const PageTopBar: React.FC = () => {
  const backFunction = useBackFunction(Paths.Goals);

  return (
    <Styled.Container>
      <TopBarBase hideBorder mobileNavigationSlot={<NavigationTabs />}>
        <Styled.Content>
          <IconButton
            icon={ArrowLeft18}
            size={Sizes.Medium}
            onClick={backFunction}
            preventDrag
          />
          <Suspense fallback={<LoadingTitle />}>
            <Styled.Title>
              <Title />
            </Styled.Title>
          </Suspense>

          <Styled.NavigationContainer>
            <NavigationTabs />
          </Styled.NavigationContainer>

          <Styled.InteractionsContainer>
            <Suspense fallback={<LoadingInteractions />}>
              <Interactions />
            </Suspense>
          </Styled.InteractionsContainer>
        </Styled.Content>
      </TopBarBase>
    </Styled.Container>
  );
};
